<template>
    <div
        :class="['tw:bg-gray-200 tw:rounded tw:animate-pulse', height, customClass]"
    ></div>
</template>

<script>
    export default { inheritAttrs: false };
</script>

<script setup>
    defineProps({
        customClass: { type: String, default: '' },
        height:      { type: String, default: 'tw:p-2' },
    });
</script>
